import ActiveBLs from '@/gql/orders/ActiveBLs.gql';

export function normalizeBlNumber(bl: string | undefined | null): string {
  return String(bl || '').trim().toUpperCase();
}

export function blNumbersMatch(
  a: string | undefined | null,
  b: string | undefined | null,
): boolean {
  return normalizeBlNumber(a) === normalizeBlNumber(b);
}

export function findActiveBl(
  activeBls: any[] | undefined | null,
  blNumber: string | undefined | null,
): any | undefined {
  if (!activeBls?.length || !blNumber) {
    return undefined;
  }
  return activeBls.find((bl) => blNumbersMatch(bl.billOfLadingId, blNumber));
}

export function blExistsInActiveBls(
  activeBls: any[] | undefined | null,
  blNumber: string | undefined | null,
): boolean {
  return !!findActiveBl(activeBls, blNumber);
}

export function activeBlPrefillKey(blNumber: string, activeBl: any): string {
  const containerCount = activeBl?.containers?.length ?? 0;
  return `${normalizeBlNumber(blNumber)}:${containerCount}`;
}

export const ACTIVE_BLS_REFETCH = { query: ActiveBLs };
